import { useAddFileUrlMutation } from "src/services/FilePickerServices";
import { IMAGE_BASE_URL } from "src/utils/constants";
import { showToast } from "src/utils/showToaster";

const useFilePicker: any = () => {
  const [fileUpload, fileUploadInfo] = useAddFileUrlMutation();

  const uploadFile = async (file: any) => {
    try {
      if (!file) return;

      const formData = new FormData();
      formData.append("bucketName", "GEEKSDOOR");
      formData.append("file", file, file?.name);

      const responseImage: any = await fileUpload(formData);
      const httpImgUrl = IMAGE_BASE_URL?.concat(
        `/${responseImage?.data?.file_path}`
      );
      return httpImgUrl || "";
    } catch (error: any) {
      showToast("error", error.message);
      throw error; // Rethrow the error to let the calling code handle it
    }
  };

  return { uploadFile, isLoading: fileUploadInfo?.isLoading };
};

export default useFilePicker;

// import { useState, useEffect } from "react";
// import { useAddFileUrlMutation } from "src/services/FilePickerServices";
// import { IMAGE_BASE_URL } from "src/utils/constants";
// import { showToast } from "src/utils/showToaster";

// export const useFilePicker = (file: any) => {
//   const [imageUrl, setImageUrl] = useState<string>("");

//   const [fileUpload, fileUploadInfo] = useAddFileUrlMutation();

//   useEffect(() => {
//     if (!file) return;
//     try {
//       const formData = new FormData();
//       formData.append("bucketName", "GEEKSDOOR");
//       formData.append("file", file, file?.name);
//       const responseImage = fileUpload(formData);
//       responseImage.then((res: any) => {
//         const httpImgUrl = IMAGE_BASE_URL?.concat(`/${res?.data?.file_path}`);
//         console.log("httpImgUrl", httpImgUrl);
//         setImageUrl(httpImgUrl || "");
//       });
//     } catch (error: any) {
//       showToast("error", error.message);
//     }
//   }, [file, fileUpload]);

//   return { imageUrl, fileUploadInfo: fileUploadInfo?.isLoading };
// };
